// SignalPath design tokens and formatters.
// These mirror tailwind.config.js. Components still consume them as inline
// style values; the Tailwind migration (next PR) replaces the usage, not the
// values themselves. See ADR-019.

export const NAVY = "#08121F";
export const PANEL = "#0E1E30";
export const TEAL = "#00C4CC";
export const TEAL_DEEP = "#00A3A9";
export const CREAM = "#EDE8DF";
export const CREAM60 = "rgba(237,232,223,0.6)";
export const CREAM30 = "rgba(237,232,223,0.3)";
export const BORDER = "rgba(237,232,223,0.1)";
export const RED = "#FF4D4D";
export const AMBER = "#F5A623";
export const GREEN = "#00C896";

// The production Firebase project. Anything else is a non-production backend and
// the shell says so on screen — see EnvBadge in SignalPath.jsx.
//
// Hardcoded deliberately, and the direction matters: the badge shows when the
// running config is NOT this, so a missing or mistyped env file fails LOUD.
// Deriving "am I in demo?" from a flag in the env file gets that backwards —
// forget the flag and a demo build looks exactly like production.
export const PROD_PROJECT_ID = "signalpath-a1eef";

export const riskColor = (s) => (s >= 7 ? RED : s >= 4 ? AMBER : GREEN);
export const riskLabel = (s) => (s >= 7 ? "High" : s >= 4 ? "Moderate" : "Low");
export const statusColor = (s) => (s === "automated" ? RED : s === "augmented" ? AMBER : GREEN);
export const pathwayColor = (t) => (t === "pivot" ? TEAL : t === "elevate" ? GREEN : AMBER);

export const fmt = (n) =>
  n >= 1e6 ? (n / 1e6).toFixed(1) + "M" : n >= 1e3 ? (n / 1e3).toFixed(0) + "K" : n.toString();
export const fmtWage = (n) => "$" + (n >= 1e3 ? (n / 1e3).toFixed(0) + "K" : n);

export const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

// The browser calls OUR endpoint. It never calls api.anthropic.com directly and
// never holds a key — the Worker owns the model, token budget, and credentials.
// See ADR-018 and CLAUDE.md ("hard guardrails").
//
// In dev this stays relative and Vite proxies /api to the local Worker.
// In production it is the Worker's absolute URL: Firebase Hosting cannot rewrite
// to a third-party host (only Cloud Functions / Cloud Run), so the call is
// cross-origin and the Worker's CORS allowlist is what makes it safe.
export const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT || "/api/claude";

// AI Signals Top 10 Human Skills Framework (ADR-009)
export const AI_SIGNALS_HUMAN_SKILLS = [
  "First Principles Thinking",
  "Critical Thinking",
  "Emotional Intelligence",
  "Communication",
  "Strategic Leadership",
  "Creative Thinking",
  "Adaptability",
  "Asking Better Questions",
  "Defining Better Problem Statements",
  "Prompt Engineering",
];
